import { defineMessages } from 'react-intl'

import { DRAWER_STATUS } from './constants'

export const drawerStatusMessages = defineMessages({
  [DRAWER_STATUS.OPEN]: {
    id: 'salechannel.open',
    defaultMessage: 'Open'
  },
  [DRAWER_STATUS.CLOSED]: {
    id: 'salechannel.closed',
    defaultMessage: ' Closed'
  }
})
